module.exports = {"411602001":"陈州回族街道","411602002":"七一路街道","411602003":"荷花街道","411602004":"人和街道","411602005":"小桥街道","411602006":"城南","411602007":"城北","411602008":"文昌","411602009":"搬口","411602010":"金海路","411602200":"李埠口乡","411602201":"许湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411602.json
// module id = 1528
// module chunks = 0